import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=ts"

import "@/components/ui/BaseSelect.css?vue&type=style&index=0&id=0eaa8ce7&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eaa8ce7"]])

export default __exports__